/**
 * Returns true if a data_wizard skipped-row entry was skipped due to a
 * duplicate record (rather than a real validation error).
 */
export function isDuplicateSkip(row) {
  return !!(row.reason && row.reason.includes("DUPLICATE_SKIPPED:"));
}

/**
 * Splits a data_wizard skipped array into two categories and computes counts.
 *
 * @param {object} data - data_wizard status payload ({ current, total, skipped })
 * @returns {{ newRecords, duplicateSkips, realErrors }}
 */
export function parseImportResult(data) {
  const allSkipped = data.skipped || [];
  const duplicateSkips = allSkipped.filter(isDuplicateSkip);
  const realErrors = allSkipped.filter((row) => !isDuplicateSkip(row));
  const newRecords = data.current - allSkipped.length;
  return { newRecords, duplicateSkips, realErrors };
}
